<div class="pill-btn-container">
  <button class="pill-btn" (click)="onClick.emit($event)">
    <span class="pill-btn-title">
      {{ title }}
    </span>
  </button>
  <i class="fa fa-times clear-filter-btn" (click)="onClear.emit()" *ngIf="showClearBtn"></i>
</div>
